import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  ElementRef,
  OnInit,
  inject,
} from '@angular/core';
import { PermissionsService } from '../services/permissions.service';
import { SessionStorageService } from '../services/session-storage.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[hasPermission]',
})
export class HasPermissionDirective implements OnInit {
  private element = inject(ElementRef);
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private perms = inject(PermissionsService);
  private ss = inject(SessionStorageService);

  private permissions: any[] = [];
  // private logicalOp = 'AND';
  private isHidden = true;
  private permList = [];

  ngOnInit() {}

  @Input()
  set hasPermission(val) {
    if (typeof val === 'boolean') {
      this.permissions = [val];
    } else {
      this.permissions = val.split(',');
    }
    this.permList = this.ss.get('rights') || [];
    this.updateView();
  }
  private updateView() {
    if (this.checkPermission()) {
      if (this.isHidden) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isHidden = false;
      }
    } else {
      this.isHidden = true;
      this.viewContainer.clear();
    }
  }

  private checkPermission() {
    const hasPermission = this.permissions.some(x => {
      const hasPermission = false;
      // eslint-disable-next-line no-useless-escape
      const negCheck = new RegExp(/^\!/);
      const negative = negCheck.test(x);

      let formatted = x;
      formatted = negative ? formatted.replace('!', '') : formatted;
      if (this.permList && !hasPermission) {
        const permissionFound = this.permList.includes(formatted);
        if (!permissionFound && negative) {
          return true;
        } else if (permissionFound && !negative) {
          return true;
        } else {
          return false;
        }
      }
    });
    return hasPermission;
  }
}
